"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnnouncementsFunctionalityComponent = void 0;
var React = _interopRequireWildcard(require("react"));
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _Announcements = _interopRequireDefault(require("./Announcements.render"));
var _withAnnouncements = _interopRequireDefault(require("../../../../../../HOCs/withAnnouncements"));
var _withLocale = _interopRequireDefault(require("../../../../../../HOCs/withLocale"));
/**
 * Business logic for the Announcements component
 */
class AnnouncementsFunctionalityComponent extends React.PureComponent {
  componentDidUpdate() {
    const {
      unreadAnnouncementsCount,
      selected,
      onNavItemSelected
    } = this.props;
    if (!this.hasReceivedData && !selected && unreadAnnouncementsCount) {
      this.hasReceivedData = true;
      onNavItemSelected();
    }
    this.markReadOnClose();
  }
  markReadOnClose() {
    if (this.props.announcements.hasError || this.props.announcements.isLoading || !this.props.announcements || !this.props.announcements || !this.props.announcements.announcements) return;
    if (!this.props.selected && this.previouslySelected) {
      this.props.markAllAnnouncementsRead();
      this.previouslySelected = false;
    } else if (this.props.selected && !this.previouslySelected) {
      this.previouslySelected = true;
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(_Announcements.default, this.props);
  }
}

// @ts-ignore
exports.AnnouncementsFunctionalityComponent = AnnouncementsFunctionalityComponent;
var _default = exports.default = (0, _flowRight.default)(_withAnnouncements.default, _withLocale.default)(AnnouncementsFunctionalityComponent);